import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { useLandingMenuOpenContext } from './landingMenuOpenContext';
import styles from './HomepageRefreshPopup.module.scss';

interface LandingRegistrationBannerChromeProps {
  onView: () => void;
  onDismiss: () => void;
}

/**
 * Registration banner + opaque shield band in one body portal so stacking
 * stays predictable relative to #root page content.
 */
function LandingRegistrationBannerChrome({
  onView,
  onDismiss,
}: LandingRegistrationBannerChromeProps) {
  const menuOpen = useLandingMenuOpenContext();

  if (typeof document === 'undefined') {
    return null;
  }

  const hiddenUnderDrawerStyle = menuOpen
    ? {
        opacity: 0,
        visibility: 'hidden' as const,
        pointerEvents: 'none' as const,
      }
    : undefined;

  return createPortal(
    <>
      <div
        className={styles.stickyStackShield}
        data-landing-sticky-stack-shield
        style={hiddenUnderDrawerStyle}
        aria-hidden="true"
      />
      <div
        className={styles.banner}
        data-landing-registration-banner
        style={hiddenUnderDrawerStyle}
        role="region"
        aria-hidden={menuOpen}
        aria-label="Registration notice"
      >
        <div className={styles.bannerInner}>
          <div className={styles.bannerSeals} aria-hidden="true">
            <img
              className={styles.bannerSeal}
              src={`${import.meta.env.BASE_URL}images/homepage-popup.webp`}
              alt=""
              decoding="async"
            />
            <img
              className={styles.bannerSeal}
              src={`${import.meta.env.BASE_URL}images/npc-dpo-dps-seal.png`}
              alt=""
              decoding="async"
            />
          </div>
          <p className={styles.bannerText}>Registered with BIR &amp; NPC</p>
          <button type="button" className={styles.bannerView} onClick={onView}>
            View
          </button>
          <button
            type="button"
            className={styles.bannerDismiss}
            onClick={onDismiss}
            aria-label="Dismiss registration notice"
          >
            <X size={16} aria-hidden="true" />
          </button>
        </div>
      </div>
    </>,
    document.body,
  );
}

export default LandingRegistrationBannerChrome;
